import {Component, OnInit} from '@angular/core';
import {DirectorySearchRestService} from '../../shared/services/wsdirectory/directory-search-rest.service';
import {DirectorySearchResponse} from '../../shared/types/wsdirectory/directory-search-response';
import {Subject} from 'rxjs';

import {User} from '../../shared/types/security/user';
import {SecurityService} from '../../shared/services/security/security.service';
import {SelectItem} from 'primeng/api';
import {
  DirectorySearchFilter,
  DirectorySearchOptions
} from '../../shared/types/wsdirectory/directory-search-options';
import {SearchSortEnum} from '../../shared/types/wsdirectory/search-sort-enum';
import {debounceTime} from 'rxjs/operators';

@Component({
  styleUrls: ['./dashboard.component.css'],
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent implements OnInit {

  data: DirectorySearchResponse;

  user: User;

  searchChanged = new Subject<void>();

  whoWhatSearch: string = '';

  whereSearch: string = '';

  pageSize: number = 10;

  filter: DirectorySearchFilter = {
    regions: [],
    organizations: [],
    titles: [],
    areas: [],
    countries: [],
    officialNso: false
  };

  sortBy: string = '';

  sortOptions: SelectItem[] = [
    {label: '', value: ''},
    {label: 'Country', value: SearchSortEnum.COUNTRY},
    {label: 'Region', value: SearchSortEnum.REGION},
    {label: 'Last updated', value: SearchSortEnum.LAST_UPDATED}
  ];

  isAuthenticated: boolean;

  constructor(private directorySearchRest: DirectorySearchRestService,
              private securityService: SecurityService) {
  }

  ngOnInit() {
    this.securityService.getLoggedUser().subscribe(value => this.user = value);
    this.securityService.isAuthenticated().subscribe(value => {
      this.isAuthenticated = value;
    });
    this.load(0);
    this.searchChanged.pipe(
      debounceTime(500)
    ).subscribe(() => this.load(0));

    const existingFilter = sessionStorage.getItem('wsd_search');
    if (existingFilter) {
      const params = JSON.parse(existingFilter);
      this.whoWhatSearch = params.whoWhat || '';
      this.whereSearch = params.where || '';
      this.sortBy = params.sort || '';
      this.filter = params.filter || this.filter;
    }
  }

  search() {
    this.updateQueryParams();
    this.searchChanged.next();
  }

  private load(page: number) {
    this.directorySearchRest.search(this.getSearchOptions(page)).subscribe(
      (response: DirectorySearchResponse) => this.data = response
    );
  }

  onPageChange(event) {
    this.load(event.first / event.rows);
  }

  clear() {
    this.whereSearch = '';
    this.whoWhatSearch = '';
    this.sortBy = '';
    Object.keys(this.filter).forEach(key => {
      if (key === 'officialNso') {
        this.filter[key] = false;
      } else {
        this.filter[key] = [];
      }
    });
    this.search();
    sessionStorage.removeItem('wsd_search');
  }

  showClearBtn() {
    return this.whoWhatSearch ||
      this.whereSearch ||
      this.sortBy ||
      this.isFilterActive();
  }

  private isFilterActive() {
    return Object.values(this.filter).find(entry => entry.length);
  }

  private getSearchOptions(page: number): DirectorySearchOptions {
    const searchObj = {
      name: this.whoWhatSearch,
      where: this.whereSearch,
      size: this.pageSize,
      page,
      sortBy: this.sortBy
    };

    return {...searchObj, ...this.filter};
  }

  private updateQueryParams() {
    sessionStorage.setItem('wsd_search', JSON.stringify({
      where: this.whereSearch,
      whoWhat: this.whoWhatSearch,
      sort: this.sortBy,
      filter: this.filter
    }));
  }
}
